import { Alert, Logo, Spacer, PlusIcon } from '@percent/lemonade'
import HeartImage from '../../assets/images/heart.png'
import SmileImage from '../../assets/images/smile.png'

import classNames from 'classnames/bind'
import styles from './CentralCardLayout.module.scss'
import { CentralCardLayoutProps } from './CentralCardLayout.types'

const cx = classNames.bind(styles)

export const CentralCardLayout = ({
  heading = '',
  children,
  handleSubmit,
  AgentVerificationLogo,
  agentVerificationLink,
  backgroundImages = false,
  CustomHeaderImage,
  footer,
  alignCenter,
  error,
  isRebrandBanner = false,
  logoHref,
  localePicker,
}: CentralCardLayoutProps) => {
  const topOffset = isRebrandBanner ? '48px' : '0'
  const minHeightOffset = isRebrandBanner ? 'calc(100vh - 48px)' : '100vh'

  return (
    <div
      className={styles.pageContainer}
      style={{ top: topOffset, minHeight: minHeightOffset }}
    >
      {logoHref ? logoHref : <Logo className={styles.goodstackLogo} />}
      {localePicker && (
        <div className={styles.localePicker}>{localePicker}</div>
      )}
      <div
        className={cx({
          formAndImagesContainer: true,
          autoTopMargin: !!footer,
        })}
      >
        <div className={styles.formContainer}>
          {CustomHeaderImage && (
            <div className={styles.headerImageWrapper}>{CustomHeaderImage}</div>
          )}
          <form onSubmit={handleSubmit} className={styles.form}>
            {AgentVerificationLogo && (
              <>
                <div className={styles.logosWrapper}>
                  <a
                    href={agentVerificationLink}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      alt="cause-logo"
                      src={AgentVerificationLogo}
                      className={styles.causeLogo}
                    />
                  </a>
                  <Spacer axis="horizontal" size={6} />
                  <PlusIcon />
                  <Spacer axis="horizontal" size={6} />
                  <Logo className={styles.goodstackLogoSmall} />
                </div>
                <Spacer axis="vertical" size={6} />
              </>
            )}
            {heading && (
              <h5
                className={cx({ headingText: true, alignCenter })}
                data-testid="auth-view-heading"
              >
                {heading}
              </h5>
            )}
            {error && (
              <>
                <Alert variant="error" title={error} />
                <Spacer axis="vertical" size={6} />
              </>
            )}
            {children}
          </form>
        </div>
        {backgroundImages && (
          <img src={SmileImage} alt="smile" className={styles.smileImage} />
        )}
        {backgroundImages && (
          <img src={HeartImage} alt="heart" className={styles.heartImage} />
        )}
      </div>
      {footer && <div className={styles.footerWrapper}>{footer}</div>}
    </div>
  )
}
